import { NavLink } from 'react-router-dom';
import {
  Home24Regular,
  Home24Filled,
  DocumentTable24Regular,
  DocumentTable24Filled,
  PeopleCommunity24Regular,
  PeopleCommunity24Filled,
  ChartMultiple24Regular,
  ChartMultiple24Filled,
  DocumentText24Regular,
  DocumentText24Filled,
  DataTrending24Regular,
  DataTrending24Filled,
  BoxMultiple24Regular,
  BoxMultiple24Filled,
  bundleIcon,
} from '@fluentui/react-icons';
import { ROUTES } from '@/utils/constants';

const HomeIcon = bundleIcon(Home24Filled, Home24Regular);
const ProjectIcon = bundleIcon(DocumentTable24Filled, DocumentTable24Regular);
const TenantsIcon = bundleIcon(
  PeopleCommunity24Filled,
  PeopleCommunity24Regular
);
const CashFlowIcon = bundleIcon(ChartMultiple24Filled, ChartMultiple24Regular);
const ReportsIcon = bundleIcon(DocumentText24Filled, DocumentText24Regular);
const SensitivityIcon = bundleIcon(DataTrending24Filled, DataTrending24Regular);
const ScenariosIcon = bundleIcon(BoxMultiple24Filled, BoxMultiple24Regular);

interface SidebarProps {
  isOpen: boolean;
}

interface NavItem {
  label: string;
  path: string;
  icon: React.ComponentType<{ className?: string }>;
}

const navItems: NavItem[] = [
  { label: 'Dashboard', path: ROUTES.DASHBOARD, icon: HomeIcon },
  { label: 'Project Details', path: ROUTES.PROJECT_DETAILS, icon: ProjectIcon },
  { label: 'Cash Flow', path: ROUTES.CASH_FLOW, icon: CashFlowIcon },
  { label: 'Tenants', path: ROUTES.TENANTS, icon: TenantsIcon },
  { label: 'Scenarios', path: ROUTES.SCENARIOS, icon: ScenariosIcon },
  { label: 'Sensitivity', path: ROUTES.SENSITIVITY, icon: SensitivityIcon },
  { label: 'Reports', path: ROUTES.REPORTS, icon: ReportsIcon },
];

export function Sidebar({ isOpen }: SidebarProps) {
  if (!isOpen) return null;

  return (
    <aside className="w-[280px] bg-sidebar-bg border-r border-border-light flex flex-col">
      <nav className="flex-1 p-0">
        <ul className="space-y-0">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-5 py-3 transition-colors ${
                    isActive
                      ? 'bg-[#ECEBEA] text-dark-text font-medium border-l-4 border-salesforce-blue'
                      : 'text-gray-300 hover:bg-[#F3F3F3] border-l-4 border-transparent'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <item.icon
                      className={`text-xl ${isActive ? 'opacity-100' : 'opacity-60'}`}
                    />
                    <span className="text-[15px]">{item.label}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-5 border-t border-border-light bg-white">
        <p className="text-xs text-gray-300">Version 1.0.0</p>
        <p className="text-xs text-gray-300 mt-1">
          Real Estate Development Model
        </p>
      </div>
    </aside>
  );
}
